import { render, staticRenderFns } from "./CreditAssignmentRequestForm.vue?vue&type=template&id=79bb9937&"
import script from "./CreditAssignmentRequestForm.vue?vue&type=script&lang=js&"
export * from "./CreditAssignmentRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports